import { initGraphQLTada } from 'gql.tada';
import type { introspection } from '../../graphql-env';

export const graphql = initGraphQLTada<{
  disableMasking: true;
  introspection: introspection;
  scalars: {
    Uri: string;
    SchoolPageSlug: string;
    SchoolPageURL: string;
    PagePathname: string;
    PropertyPageURL: string;
  };
}>();
